import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from "../../../../../components/custom/CustomButton";

const AssignStaff = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  function onCancel() {
    navigate("/detail-savings-account", { state: state });
  }

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.assignSavingsOfficer}
        pageItems={staticConfig.assignSavingsOfficerBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            // initialValues={formData.customerAddressInfo}
            form={form}
            layout="vertical"
            // onFinish={handleAddressSave}
          >
            <Row>
              <Divider />

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.toSavingsOfficer}
                  name={"toSAvingsOfficer"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.toSavingsOfficer),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.toSavingsOfficer, "select")}
                    // options={addressTypeIdData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.assignmentDate}
                  name={"assignmentDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.assignmentDate),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 35 }}
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.assignmentDate)}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Save"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default AssignStaff;
